import { render } from "./StaffToForecastCensus.vue?vue&type=template&id=1dbdf961&scoped=true&ts=true"
import script from "./StaffToForecastCensus.vue?vue&type=script&lang=ts"
export * from "./StaffToForecastCensus.vue?vue&type=script&lang=ts"

import "./StaffToForecastCensus.vue?vue&type=style&index=0&id=1dbdf961&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbdf961"]])

export default __exports__